export default __webpack_public_path__ + "static/media/contact-us.0cb16c22.jpg";